// FYI, this page is almost 100% hardcoded for 1 report

import React, { useEffect, useState } from 'react';
import { Menu, Dropdown, DropdownProps, Table, MenuItemProps } from 'semantic-ui-react';
import DateInput from '../components/elements/DateInput';
import { SemanticDatepickerProps } from 'react-semantic-ui-datepickers/dist/types';
import Button from '../components/elements/Button';
import API from '../utils/network';
import { isNullOrUndefined } from '../utils/siteFunctions';
import dayjs from 'dayjs';
import AccountsReport, { AccountsReportRow } from '../components/controls/AccountsReport';
import CustomReport, { CustomReportData } from '../components/controls/CustomReport';

const ReportsPage = ():React.ReactElement => {
	/// Local state
	const [ reportNames, setReportNames ] = useState<ReportName[]>([]);
	const [ selectedReportName, setSelectedReportName ] = useState<ReportName | undefined>(undefined);
	const [ filters, setFilters ] = useState<Filters>({ fromDate: undefined, toDate: undefined });
	const [ accountsReportRows, setAccountsReportRows ] = useState<AccountsReportRow[]>([]);
	const [ customReportData, setCustomReportData ] = useState<CustomReportData | undefined>(undefined);

	/// Events
	const handleGenerateReportClick = e => {
		if (selectedReportName?.reportType === 'stock') {
			API.post('/reports/account-report', { StartDate: filters.fromDate, EndDate: filters.toDate })
				.then(data => setAccountsReportRows(data.data))
				.catch(error => console.error('Error', error));
		}
		else if (selectedReportName?.reportType === 'custom') {
			API.post('/reports/report', { Id: selectedReportName.reportId, Type: selectedReportName.reportType })
				.then(data => setCustomReportData(data.data))
				// .then(data => console.log(data))
				.catch(error => console.error('Error', error));
		}
	};

	const handleDateFilterChange = (e, { value, name }: SemanticDatepickerProps) => {
		setFilters(prevState => ({
			...prevState,
			[name]: value
		}));
	};

	const handleMenuItemClick = (e, { value }: MenuItemProps) => {
		setAccountsReportRows([]);
		setCustomReportData(undefined);
		setSelectedReportName(value);
	};

	/// Effects
	useEffect(() => {
		API.get('/reports/report-ids-and-names')
			.then(data => {
				setReportNames(data.data.map(x => ({
					reportId: x.id,
					reportType: x.type,
					reportName: x.name
				})));
			})
			.catch(error => console.error('Error', error));
	}, []);

	/// Render
	return (
		<div
			style={{
				display: 'grid',
				gridTemplateColumns: 'max-content 1fr',
				gridTemplateRows: 'max-content 1fr',
				height: '100%'
			}}
		>
			<div
				style={{
					gridRowEnd: 'span 2',
					padding: '1em',
					borderRight: '1px solid #c4c4c4'
				}}
			>
				<h2>Reports</h2>
				<Menu vertical value={selectedReportName}>
					{reportNames.map((x, index) =>
						<Menu.Item key={index} value={x} active={x.reportId === selectedReportName?.reportId} onClick={handleMenuItemClick}>{x.reportName}</Menu.Item>
					)}
				</Menu>
			</div>
			{ !isNullOrUndefined(selectedReportName) &&
				<>
					<div>
						<div
							style={{
								margin: '1em 0 0 1em'
							}}
						>
							<h3>{selectedReportName?.reportName}</h3>
						</div>
						<div
							style={{
								display: 'inline-grid',
								gridAutoFlow: 'column',
								columnGap: '1em',
								margin: '1em',
								gridTemplateRows: 'repeat(2, max-content)',
								gridTemplateColumns: 'repeat(4, max-content)'
							}}
						>
							{selectedReportName?.reportType === 'stock' &&
							<>
								Start Date
								<DateInput
									value={filters.fromDate}
									onChange={handleDateFilterChange}
									name="fromDate"
								/>
								End Date
								<DateInput
									value={filters.toDate}
									onChange={handleDateFilterChange}
									name="toDate"
								/>
								<div />
							</>}
							<div style={{display: 'flex', alignItems: 'center'}}>
								<Button secondary onClick={handleGenerateReportClick}>Generate Report</Button>
							</div>
						</div>
					</div>
					{selectedReportName?.reportType === 'stock' && <AccountsReport accountsReportRows={accountsReportRows} />}
					{selectedReportName?.reportType === 'custom' && <CustomReport customReportData={customReportData} />}
				</>
			}
		</div>
	);
};

const clients: Client[] = [
	{
		id: 1,
		name: 'Test Client'
	},
	{
		id: 2,
		name: 'Test Client 2'
	}
];

interface Client {
	id: number;
	name: string;
}

interface ReportName {
	reportId: number;
	reportType: string;
	reportName: string;
}

interface Filters {
	fromDate?: Date,
	toDate?: Date
}

interface DropdownItem {
	key: any;
	value: string;
}

export default ReportsPage;